import React, { useRef } from 'react';
import { motion, useScroll, useTransform, useReducedMotion } from 'framer-motion';

/**
 * A full-width image band that drifts slightly slower than the page while it
 * crosses the viewport. The wrapper keeps the layout height stable; only the
 * image inside moves.
 */
const ParallaxImage = ({ src, alt = '', className = '', amount = 40, ...rest }) => {
  const ref = useRef(null);
  const reduceMotion = useReducedMotion();
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['start end', 'end start'],
  });
  const y = useTransform(scrollYProgress, [0, 1], [amount, -amount]);

  return (
    <figure ref={ref} className={`parallax-figure ${className}`.trim()} {...rest}>
      <motion.img
        src={src}
        alt={alt}
        loading="lazy"
        decoding="async"
        className="parallax-figure-img"
        style={reduceMotion ? undefined : { y }}
      />
    </figure>
  );
};

export default ParallaxImage;
